<template>
  <v-data-table
    :search="searchInput"
    :headers="subjectHeaders"
    :items="subjects"
    :loading="subjectsLoading"
    :footer-props="{
      itemsPerPageOptions: subjectsPerPage,
    }"
  >
    <template v-slot:[`item.icon`]="{ item }">
      <v-chip :class="`secondary-${item.color}-bg`" label text-color="white">
        <v-icon :color="item.color">mdi-{{ item.icon }}</v-icon>
      </v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn-toggle rounded>
        <v-btn
          class="remove-toggled-state"
          small
          color="success"
          @click="openDialog('view', item.id)"
        >
          <v-icon small color="white"> mdi-eye </v-icon>
        </v-btn>
        <v-btn
          class="remove-toggled-state"
          small
          color="primary"
          @click="openDialog('edit', item.id)"
        >
          <v-icon small color="white"> mdi-pencil </v-icon>
        </v-btn>
        <v-btn
          class="remove-toggled-state"
          small
          color="error"
          @click="openDialog('delete', item.id)"
        >
          <v-icon small color="white">mdi-delete</v-icon>
        </v-btn>
      </v-btn-toggle>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "SubjectList",
  props: {
    searchInput: {
      type: String,
      default: "",
    },
    filterSubjectsByGrade: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      subjectsPerPage: [10, 15, 25, 50, 100],
    };
  },
  computed: {
    subjects: function () {
      return this.$store.state._subjectsModule.subjects;
    },
    subjectsLoading: function () {
      return this.$store.state._subjectsModule.subjectsLoading;
    },
    subjectHeaders: function () {
      return [
        {
          text: "Subject Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Code",
          align: "start",
          sortable: true,
          value: "code",
        },
        {
          text: "Icon (Color)",
          align: "center",
          sortable: true,
          value: "icon",
        },
        {
          text: "Grade Level",
          align: "center",
          sortable: true,
          value: "gradeLevel",
          filter: (value) => {
            if (!this.filterSubjectsByGrade) {
              return true;
            }
            return this.filterSubjectsByGrade == value;
          },
        },
        {
          text: "Actions",
          align: "center",
          value: "actions",
        },
      ];
    },
  },
  methods: {
    openDialog(action, subjectId) {
      this.$emit("openDialog", { action: action, subjectId: subjectId });
    },
  },
  async mounted() {
    await this.$store.dispatch("_subjectsModule/getSubjects");
  },
};
</script>
<style scoped>
.remove-toggled-state {
  color: white !important;
}
</style>
